import { fetchPricingRegions } from '@/services/products'

/**
 * Mutation types of the store
 */
const mutationTypes = {
  FETCHING: 'FETCHING',
  FETCHED: 'FETCHED'
}

/**
 * Initial state
 */
const state = {
  loading: false,
  pricingRegions: undefined
}

/**
 * Getters
 */
const getters = {}

/**
 * Actions
 */
const actions = {
  fetchPricingRegions({ commit }) {
    commit(mutationTypes.FETCHING)

    return fetchPricingRegions()
      .then((pricingRegions) => {
        commit(mutationTypes.FETCHED, pricingRegions)
      })
      .catch((err) => {
        console.log(err)
        commit(mutationTypes.FETCHED, [])
      })
  }
}

/**
 * Mutations
 */
const mutations = {
  [mutationTypes.FETCHING](state) {
    state.loading = true
  },

  [mutationTypes.FETCHED](state, pricingRegions) {
    state.pricingRegions = pricingRegions
    state.loading = false
  }
}

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
}
